import { Battery } from 'lucide-react';
import type { Site } from '../../hooks/useSites';
import type { TelemetryPresence } from './derive';

// The subline reports whether telemetry is arriving; it never shows the
// numbers themselves — a commissioning site's data is not yet trusted (#789).
const TELEMETRY_SUBLINE: Record<TelemetryPresence, string> = {
  live: 'Telemetry live · not yet in service',
  stale: 'Telemetry stale',
  none: 'No live telemetry yet',
};

// Explicit pre-commissioning state (kpi_metadata.commissioning_status) —
// never inferred from missing telemetry, never fake zeros (spec §6.1).
export function CommissioningPanel({
  site,
  telemetry,
}: {
  site: Site;
  telemetry: TelemetryPresence;
}) {
  const parsedLegacy =
    site.capacity_mwh != null ? parseFloat(String(site.capacity_mwh)) : NaN;
  const mwh =
    site.bess_energy_mwh ?? (Number.isFinite(parsedLegacy) && parsedLegacy > 0 ? parsedLegacy : null);
  return (
    <>
      <div className="mt-4 rounded-xl border border-dashed border-ems-text-muted/30 bg-ems-text-muted/5 p-4 text-center">
        <div className="text-xs font-bold tracking-wider text-ems-text-secondary">
          COMMISSIONING
        </div>
        <div className="mt-1 text-[11px] text-ems-text-muted">{TELEMETRY_SUBLINE[telemetry]}</div>
      </div>
      <div className="mt-3 rounded-xl bg-ems-bg p-2.5 opacity-60">
        <div className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-ems-text-muted">
          <Battery className="h-3 w-3" /> BESS
        </div>
        <div className="mt-1 text-[11px] text-ems-text-secondary">
          {mwh != null
            ? `${Number(mwh.toFixed(1))} MWh installed · awaiting commissioning`
            : 'Awaiting commissioning'}
        </div>
      </div>
    </>
  );
}
